export default {
  PERIODS(state, data) {
    state.periods = data
  },
  ORGANIZATIONS(state, data) {
    state.organizations = data
  },

  FRESH(state) {
    state.quoteAgreement = {
    }
  },
  LIST(state, data) {
    state.list = data
  },
  UPDATE(state, data) {
    state.quoteAgreement = {
      id: data.id,
    }
  },
}
